export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9376.bff4c70d.jpg";